import * as React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import CustomThemeProvider from './ThemeProvider';
import CustomAmountPriceContainer from '../../Containers/CustomAmountPrice';
import ProductPart from '../../Components/ProductPart';
import BaseProductPartsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList';
import Header from '../../Components/Header/Header';
import useCustomOptionClassifications from '../../Hooks/useCustomOptionClassifications';
import OptionsList from '../../Components/OptionsList';
import { selectOption, viewOptionDetails } from '../../Reducers/Configurator/Actions';
import OptionDetailContainer from '../../Components/Optiondetail/Optiondetail';

export default (props) => {
  const {
    optionclassifications,
    selectedOptionClassification: selectedOptionClassificationOrGroup,
    options,
    componentGroupComponents,
    onSelectOptionClassification,
    onSelectOption,
  } = useCustomOptionClassifications();

  return (
    <ConnectedConfiguratorScreen
      {...props}
      ThemeProvider={CustomThemeProvider}
      renderAmountPrice={(props) => <CustomAmountPriceContainer {...props} />}
      renderHeader={() => <Header />}
      renderProductParts={(dispatchAction, onOptionClassificationSelect, selectOptionClassification) => (
        <>
          <BaseProductPartsListContainer
            ProductPartComponent={ProductPart}
            onSelect={onSelectOptionClassification(
              dispatchAction,
              onOptionClassificationSelect,
              selectOptionClassification
            )}
            optionclassifications={optionclassifications}
            selectedoptionclassification={selectedOptionClassificationOrGroup}
          />
        </>
      )}
      renderOptionsList={(
        selectOption,
        dispatchAction,
        viewOptionDetails,
        onToggle,
        onToggleOptionList,
        OptionsListContainer
      ) => (
        <OptionsListContainer
          onSelect={onSelectOption(dispatchAction, selectOption)}
          viewDetails={(option) => viewOptionDetails(dispatchAction, option)}
          onToggle={() => onToggle(onToggleOptionList)}
          optionclassification={selectedOptionClassificationOrGroup}
          options={options}
          Component={OptionsList}
          componentGroupComponents={componentGroupComponents}
        />
      )}
      viewOptionDetails={(dispatchAction, option) => dispatchAction(viewOptionDetails(option))}
      selectOption={(
        dispatchAction,
        option,
        refreshOptionList = true,
        showOptionDetails = false,
        optionClassification = false
      ) => dispatchAction(selectOption(option, refreshOptionList, showOptionDetails, optionClassification))}
      renderOptionDetailContainer={(selectOption, dispatchAction, viewOptionDetails) => (
        <OptionDetailContainer
          onSelect={(option) => selectOption(dispatchAction, option)}
          viewDetails={(option) => viewOptionDetails(dispatchAction, option)}
        />
      )}
    />
  );
};
